import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.style.opacity = "0"
    this.element.style.transform = "translateY(-8px)"
    this.element.style.transition = "opacity 220ms cubic-bezier(0.23,1,0.32,1), transform 220ms cubic-bezier(0.23,1,0.32,1)"

    // Force reflow, then enter
    this.element.offsetHeight
    this.element.style.opacity = "1"
    this.element.style.transform = "translateY(0)"

    this.timeout = setTimeout(() => this.close(), 5000)
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  close() {
    if (this.timeout) clearTimeout(this.timeout)
    this.element.style.opacity = "0"
    this.element.style.transform = "translateY(-8px)"
    this.element.addEventListener("transitionend", () => this.element.remove(), { once: true })
  }
}
